import React from 'react';
import { Form, Card, Input, Button, Checkbox, InputNumber, Radio } from 'antd';
import { connect } from 'dva';
import { formItemLayout } from 'utils/utils.js';
import { mobileRegExp, idCardRegExp } from 'utils/regexp-utils.js';
import styles from './Index.less';

const FormItem = Form.Item;
const RadioGroup = Radio.Group;

@connect(({ operationMerchantAddOrUpdate, loading }) => ({
  personalInfoFormData: operationMerchantAddOrUpdate.personalInfoFormData,
  merchantId: operationMerchantAddOrUpdate.merchantId,
  submitting: loading.effects['operationMerchantAddOrUpdate/addOrUpdateMerchantPersonal'],
  loading: loading.effects['operationMerchantAddOrUpdate/fetchPersonalInfo'],
}))
@Form.create()
export default class PersonalInfo extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isEnable: false,
      accountType: 0,
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleOnCheck = this.handleOnCheck.bind(this);
    this.handleChangeType = this.handleChangeType.bind(this);

    this.renderName = this.renderName.bind(this);
    this.renderPhone = this.renderPhone.bind(this);
    this.renderIdentityNo = this.renderIdentityNo.bind(this);
    this.renderRate = this.renderRate.bind(this);
  }

  componentDidMount() {
    const { form, personalInfoFormData, merchantIdForEditOrQuery, type } = this.props;

    if (type === 'add') {
      form.setFieldsValue(personalInfoFormData);
      // eslint-disable-next-line
      this.setState({
        isEnable: personalInfoFormData.isEnable,
        accountType: personalInfoFormData.type || 0,
      });
    } else if (type === 'edit' || type === 'query') {
      this.props
        .dispatch({
          type: 'operationMerchantAddOrUpdate/fetchPersonalInfo',
          merchantId: merchantIdForEditOrQuery,
        })
        .then(personalInfo => {
          this.setState({
            isEnable: personalInfo.isEnable,
            accountType: personalInfo.type,
          });
        });
    }
  }

  handleSubmit(e) {
    e.preventDefault();

    const { form, merchantId, dispatch, successCallback } = this.props;
    const { accountType } = this.state;

    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        dispatch({
          type: 'operationMerchantAddOrUpdate/addOrUpdateMerchantPersonal',
          personalInfoFormData: {
            ...values,
            type: accountType,
          },
          merchantId,
        }).then(() => {
          if (successCallback) {
            successCallback();
          }
        });
      }
    });
  }

  handleOnCheck(e) {
    const { type } = this.props;
    if (type === 'query') {
      return;
    }

    this.setState({
      isEnable: e.target.checked,
    });
  }

  handleChangeType(e) {
    const { type } = this.props;
    if (type === 'query') {
      return;
    }

    this.setState(
      {
        accountType: e.target.value,
      },
      () => {
        this.props.form.setFields({
          identityNo: {
            value: '',
          },
        });
      }
    );
  }

  renderName() {
    const { type, personalInfoFormData: { name } } = this.props;
    if (type === 'query') {
      return <span>{name}</span>;
    }

    return <Input placeholder="请输入" />;
  }

  renderPhone() {
    const { type, personalInfoFormData: { phone } } = this.props;
    if (type === 'query') {
      return <span>{phone}</span>;
    }

    return <Input placeholder="请输入" />;
  }

  renderIdentityNo() {
    const { type, personalInfoFormData: { identityNo } } = this.props;
    if (type === 'query') {
      return <span>{identityNo}</span>;
    }

    return <Input placeholder="请输入" />;
  }

  renderRate() {
    const { type, personalInfoFormData: { rate } } = this.props;
    if (type === 'query') {
      return <span>{rate}‰</span>;
    }

    return (
      <InputNumber
        placeholder="请输入"
        precision={1}
        min={2.5}
        max={15}
        formatter={value => `${value}‰`}
        parser={value => value.replace('‰', '')}
      />
    );
  }

  render() {
    const {
      submitting,
      submitText,
      submitLeftExtraActions,
      cardTitle,
      className,
      loading,
      type,
    } = this.props;
    const { accountType, isEnable } = this.state;
    const { personalInfoFormData } = this.props;
    const { getFieldDecorator } = this.props.form;
    const identityNoName = accountType === 0 ? '身份证号' : '统一社会信用代码';

    return (
      <Card
        bordered={false}
        className={`${styles.root} ${className}`}
        title={cardTitle}
        loading={loading}
      >
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} label="账户类型">
            <RadioGroup value={accountType} onChange={this.handleChangeType}>
              <Radio value={0}>个人</Radio>
              <Radio value={1}>企业</Radio>
            </RadioGroup>
          </FormItem>

          <FormItem {...formItemLayout} label="姓名">
            {getFieldDecorator('name', {
              initialValue: personalInfoFormData.name,
              rules: [
                { required: true, message: '请输入账户名' },
                { max: 32, message: '账户名不能超多32个字' },
              ],
            })(this.renderName())}
          </FormItem>

          <FormItem {...formItemLayout} label="手机号">
            {getFieldDecorator('phone', {
              initialValue: personalInfoFormData.phone,
              rules: [
                { required: true, message: '请输入手机号' },
                { pattern: mobileRegExp, message: '请输入正确的手机号' },
              ],
            })(this.renderPhone())}
          </FormItem>

          <FormItem {...formItemLayout} label={identityNoName}>
            {getFieldDecorator('identityNo', {
              initialValue: personalInfoFormData.identityNo,
              rules: [
                { required: true, message: `请输入${identityNoName}` },
                {
                  validator: (rule, value, cb) => {
                    if (accountType === 0 && idCardRegExp.test(value) === false) {
                      return cb('请输入正确的身份证号');
                    }

                    return cb();
                  },
                },
              ],
            })(this.renderIdentityNo())}
          </FormItem>

          <FormItem {...formItemLayout} label="结算费率">
            {getFieldDecorator('rate', {
              initialValue: personalInfoFormData.rate,
            })(this.renderRate())}
          </FormItem>

          <FormItem {...formItemLayout} label=" " className="no-colon">
            {getFieldDecorator('isEnable')(
              <Checkbox checked={isEnable} onChange={this.handleOnCheck}>
                开通校之付账户（未勾选时，仅作为运营者）
              </Checkbox>
            )}
          </FormItem>

          {type !== 'query' && (
            <FormItem className="operation-button-wrap">
              {submitLeftExtraActions}
              <Button type="primary" htmlType="submit" loading={submitting}>
                {submitText}
              </Button>
            </FormItem>
          )}
        </Form>
      </Card>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/Merchant/components/PersonalInfo/Index.js